<template>
  <div>
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'VFatherPatAppointments',
  components: {},
};
</script>
